"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Variables = void 0;
class Variables {
}
exports.Variables = Variables;
Variables.NATIVE_TOKEN_ADDRESS = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE'; // For sending native (ETH/FUSE) tokens
Variables.BASE_URL = (_a = process.env.BASE_URL) !== null && _a !== void 0 ? _a : 'api.fuse.io';
Variables.SOCKET_SERVER_URL = (_b = process.env.SOCKET_SERVER_URL) !== null && _b !== void 0 ? _b : 'wss://ws.fuse.io/connection/websocket';
Variables.ETHERSPOT_FACTORY = (_c = process.env.ETHERSPOT_FACTORY) !== null && _c !== void 0 ? _c : '0x7f6d8F107fE8551160BD5351d5F1514A6aD5d40E';
Variables.DEFAULT_TX_OPTIONS = {
    feePerGas: '10000000000',
    feeIncrementPercentage: 10,
    withRetry: false,
    useNonceSequence: false,
};
